/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ConfigurazioneTestResponse { 
    esito?: ConfigurazioneTestResponseEsitoEnum;
    durata_ms?: number;
    causa?: ConfigurazioneTestResponseCausaEnum;
    dettaglio?: string;
}
export enum ConfigurazioneTestResponseEsitoEnum {
    OK = 'OK',
    ERRORE = 'ERRORE'
};
export enum ConfigurazioneTestResponseCausaEnum {
    AUTH_FAILED = 'AUTH_FAILED',
    HOST_UNREACHABLE = 'HOST_UNREACHABLE',
    SSL_ERROR = 'SSL_ERROR',
    TIMEOUT = 'TIMEOUT',
    RECIPIENT_REJECTED = 'RECIPIENT_REJECTED'
};



